/**
 * InfoNote — a small hint row (icon + faint text) under fields / cards.
 */
import { Info, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface InfoNoteProps {
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
}

export function InfoNote({ icon: Icon = Info, children, className }: InfoNoteProps) {
  return (
    <div
      className={cn('flex items-start gap-2 text-[12.5px] leading-normal text-faint', className)}
    >
      <Icon className="mt-0.5 h-3.5 w-3.5 flex-none" />
      <span>{children}</span>
    </div>
  );
}
